 <!---Global-loader-->
 <!-- <div style="height:100vh;" id="glb-loader" class="loaderShow">
  <img src="./assets/img/loader.svg" class="loader-img" alt="loader">
</div> -->
<!--- End Global-loader-->

<ngx-spinner bdColor="#818EB5" template="<img src='assets/loaders/vikingo.gif' />"></ngx-spinner> 
<router-outlet></router-outlet>
  